import React from 'react';
import { initialAuthentication } from './authentication';

const AuthenticationContext = React.createContext(initialAuthentication);

export default AuthenticationContext;
